(function() { module.exports = window["Next"]["Table"]; }());